module.exports = __webpack_public_path__ + "img/profile-icon.d43ce984.svg";